module.exports = __webpack_public_path__ + "fd626836c1a8a991dc01da0f0359a911.woff";


//////////////////
// WEBPACK FOOTER
// ./www/app/content/themes/rikssalsstiftelsen/static/fonts/Alegreya-Regular.woff
// module id = 9
// module chunks = 0